import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { InvmaearticuloService } from '../../inv/invservicios/invmaearticulo.service';
import { InvmaebodegaService } from '../../inv/invservicios/invmaebodega.service';
import { InvmaeunidadesService } from '../../inv/invservicios/invmaeunidades.service';
//import { AggridsaciComponent } from '../aggridsaci/aggridsaci.component';
import { AggridsacicotComponent } from "../aggridsacicot/aggridsacicot.component";
import { InvtomafisicaService } from '../../inv/invservicios/invtomafisica.service';
import { BancierrecajaService } from '../../ban/banservicios/bancierrecaja.service';
import { DatePipe } from '@angular/common';
import { CommaeservicioService } from '../../com/comservicios/commaeservicio.service';
import { VenencpedService } from '../../ven/venservicios/venencped.service';
import { PagocontadoService } from '../../ven/venservicios/pagocontado.service';
import { VenencfacService } from '../../ven/venservicios/venencfac.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { ComencordcomService } from '../../com/comservicios/comencordcom.service';
import { InventradaService } from '../../inv/invservicios/inventrada.service';
import { InvsalidaService } from '../../inv/invservicios/invsalida.service';
import { InvtrnkardexotrService } from '../../ven/venservicios/invtrnkardexotr.service';
import { VenenguiaRemisionService } from '../../ven/venservicios/venenguia-remision.service';
import { ConmaeconService } from '../../cont/conservicios/conmaecon.service';
import { CommaeproveedorService } from '../../com/comservicios/commaeproveedor.service';
import { VenencdevfacService } from '../../ven/venservicios/venencdevfac.service';
import { ComnotrecService } from '../../com/comservicios/comnotrec.service';
import { ComencfacproService } from '../../com/comservicios/comencfacpro.service';
import { ComencdevfacService } from '../../com/comservicios/comencdevfac.service';
import { CxccarteraactivaService } from '../../cxc/cxcservicios/cxccarteraactiva.service';
import { CxctrnpagoretService } from '../../cxc/cxcservicios/cxctrnpagoret.service';
import { ComtrndistribucionccService } from '../../com/comservicios/comtrndistribucioncc.service';
import { CxptrnpagodocumentoService } from '../../com/comservicios/cxptrnpagodocumento.service';
import { ActualizacionpreciosfpService } from '../../com/comservicios/actualizacionpreciosfp.service';
import { CxcmaeretencionService } from 'src/app/cxc/cxcservicios/cxcmaeretencion.service';
import { ConencasilService } from '../../cont/conservicios/conencasil.service';
import { BantrnbaneditService } from '../../ban/banservicios/bantrnbanedit.service';
import { ContrndistribpccService } from '../../cont/conservicios/contrndistribpcc.service';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { BanconcilbancariaService } from '../../ban/banservicios/banconcilbancaria.service';
import { BantrntarjetaService } from '../../ban/banservicios/bantrntarjeta.service';
import { BantrncajaService } from '../../ban/banservicios/bantrncaja.service';
import { InvenctransferService } from '../../inv/invservicios/invenctransfer.service';
import { MessageService } from 'primeng';
import { CxptrncobroService } from '../../cxp/cxpservicios/cxptrncobro.service';
import { NommaedepartamentoService } from '../../nom/nomservicios/nommaedepartamento.service';
import { SegmaeusuarioService } from '../../seg/segservicios/segmaeusuario.service';
import { SegmaecompaniaService } from '../../seg/segservicios/segmaecompania.service';
import { SacimaeconfiguracionService } from '../../seg/segservicios/sacimaeconfiguracion.service';
import { CxpenccuotaService } from '../../cxp/cxpservicios/cxpenccuota.service';
import { InvtrnajustesService } from '../../inv/invservicios/invtrnajustes.service';
import { SacimaenumeracionCService } from 'src/app/seg/segservicios/sacimaenumeracion-c.service';
import { SegmaenumeraciongService } from 'src/app/seg/segservicios/segmaenumeraciong.service';
import { BanbandejapagosService } from '../../ban/banservicios/banbandejapagos.service';
import { NommaetablitaretService } from 'src/app/nom/nomservicios/nommaetablitaret.service';
import { NommaerubroService } from 'src/app/nom/nomservicios/nommaerubro.service';
import { InvtrnreservasService } from '../../inv/invservicios/invtrnreservas.service';
import { NomrhucabhoraextrService } from 'src/app/nom/nomservicios/nomrhucabhoraextr.service';
import { VenmaeclienteService } from 'src/app/ven/venservicios/venmaecliente.service';
import { InvtrnloteService } from 'src/app/ven/venservicios/invtrnlote.service';
import { ProdencordproService } from 'src/app/prod/prodservicios/prodencordpro.service';
import { NomutilidadesService } from 'src/app/nom/nomservicios/nomutilidades.service';
import { InvbusquedaService } from 'src/app/inv/invservicios/invbusqueda.service';
import { ActmaegrupoService } from 'src/app/act/actservicios/actmaegrupo.service';
import { ActmaepolizaService } from 'src/app/act/actservicios/actmaepoliza.service';
import { TecencordtraService } from 'src/app/tec/tecservicios/tecencordtra.service';
import { ActencsalidaService } from 'src/app/act/actservicios/actencsalida.service';
import { VenencptovtaService } from '../../ven/venservicios/venencptovta.service';
import { NomencrolService } from 'src/app/nom/nomservicios/nomencrol.service';//GSRF
//CDPJ
import { CxctrnretencionesService } from '../../cxc/cxcservicios/cxctrnretenciones.service';//CDPJ
import { CxctrnabonoService } from '../../cxc/cxcservicios/cxctrnabono.service';//CDPJ
import { CxctrncancelacionService } from '../../cxc/cxcservicios/cxctrncancelacion.service';
import { InvtrnajustenegService } from "../../inv/invservicios/invtrnajusteneg.service";
import { PresuplancuentasService } from "../../cont/conservicios/presuplancuentas.service";
import { PresucentrocostosService } from 'src/app/cont/conservicios/presucentrocostos.service';
import { ConpresuanucenService } from "../../cont/conservicios/conpresuanucen.service";
import { InvexpmaterialesService } from "../../inv/invservicios/invexpmateriales.service";
import { InvenctransferrecibidoService } from "../../inv/invservicios/invenctransferrecibido.service";
import { NomtrndistricenService } from "../../nom/nomservicios/nomtrndistricen.service";
import { ConpartidapresuService } from "../../cont/conservicios/conpartidapresu.service";
import { CondiaparpreService } from "../../cont/conservicios/condiaparpre.service";
import { InvsalidaprodService } from '../../inv/invservicios/invsalidaprod.service';
import { InventradaprodService } from "../../inv/invservicios/inventradaprod.service";
import { ConprecenService } from "../../cont/conservicios/conprecen.service";
import { CxccobromultipleService } from "../../cxc/cxcservicios/cxccobromultiple.service";
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { VenencgrepetService } from "../../ven/venservicios/venencgrepet.service";
import { VenenccotizacionService } from "../../ven/venservicios/venenccotizacion.service";
import { isNullOrUndefined } from 'util';
//CDPJ
@Component({
    selector: 'prueba-cell',
    template: `
	  <input #input pInputText *ngIf="!fecha && !regexp && !checkBool && !int" (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)" (focus)="focuact($event)" (blur)="focudes($event)"
			 [(ngModel)]="value" style="width: 100%" type="text" [maxLength]="tamanocelda">
	  <input #input pInputText *ngIf="!fecha && regexp && !checkBool && !int" (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)" (focus)="focuact($event)" (blur)="focudes($event)"
			 [(ngModel)]="value" style="width: 100%" [pKeyFilter]="regexp" [maxLength]="1">
	  <input #input pInputText *ngIf="fecha && !checkBool && !int && !regexp" type="date" (keydown)="onKeyDownFecha($event)"
			 [(ngModel)]="value" style="width: 100%">
	  <input #input pInputText *ngIf="!fecha && int && !checkBool && !regexp" (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)" (focus)="focuact($event)" (blur)="focudes($event)"
			 [(ngModel)]="value" style="width: 100%" pKeyFilter="num" [maxLength]="tamanocelda">
  `
})

export class CellEditorCotizacion implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: string;
    private cancelBeforeStart: boolean;
    public gridApi;
    public int: boolean;
    public saltoslinea: number;
    public newrow: boolean;
    public tamanocelda: number;
    public columidactual: string;
    public onlynumber: boolean;
    public onlyalphabetic: boolean;
    public onlymayusculas: boolean;
    public decimales: number;
    public fecha: boolean;
    public checkBool: boolean;
    public clave: boolean;
    public objeto: any;
    public regexp: RegExp;
    public opcionbuscar: boolean;
    public tienecalculos: boolean;
    public autorizacion: boolean;
    public noblanco: boolean;
    public nosaltar: boolean;
    public focusout: boolean;
    //GSRF
    public idcell1 = '';
    public rowcell1 = '';
    //GSRF
    //CDPJ
    public onlynumberposneg: boolean
    public nextrow: boolean
    //CDPJ
    // @ts-ignore
    @ViewChild('input', { read: ViewContainerRef }) public input;

    constructor(private messageService: MessageService, private artService: InvmaearticuloService, private bodService: InvmaebodegaService,
        private unidadService: InvmaeunidadesService, private aggrid: AggridsacicotComponent, private tomaService: InvtomafisicaService,
        private cajaService: BancierrecajaService, private datePipe: DatePipe, private comservice: CommaeservicioService,
        private encpedService: VenencpedService, private pagconservice: PagocontadoService, private encfacservice: VenencfacService,
        private confIniciales: ConfInicialesService, private encordService: ComencordcomService,
        private entradaService: InventradaService, private salidaService: InvsalidaService,
        private tomFisService: InvtomafisicaService, private trnkardexotrservice: InvtrnkardexotrService,
        private venenguiaRemisionService: VenenguiaRemisionService, private cuentaService: ConmaeconService, private proveedorService: CommaeproveedorService,
        private venDevFacService: VenencdevfacService, private comnotrecServicio: ComnotrecService,
        private encfacproService: ComencfacproService, private comDevFacService: ComencdevfacService,
       
        private trnloteservice: InvtrnloteService, private nomUtilidadesService: NomutilidadesService,
        private actmaepolizaService: ActmaepolizaService, public encordtraService: TecencordtraService,
        private init: NuevoComponentService,
        public conpartidapresuService: ConpartidapresuService,
        public condiaparpreService: CondiaparpreService,
       public venenccotizacionService:VenenccotizacionService,
        public venencgrepetService: VenencgrepetService) {
    }

    agInit(params: any): void {
        console.log(params)
        this.params = params;
        this.value = this.params.value;
        this.gridApi = params.api;
        this.saltoslinea = params.values.saltoslinea;
        this.newrow = params.values.newrow;
        this.onlynumber = params.values.numeros;
        this.onlynumberposneg = params.values.numposneg;
        this.onlyalphabetic = params.values.alphabetic;
        this.onlymayusculas = params.values.mayusculas;
        this.decimales = params.values.numerodecimales;
        this.nextrow = params.values.nextrow;

        if (params.values.regexp !== undefined) {
            this.regexp = params.values.regexp;
        }
        if (params.values.opcionbuscar !== undefined) {
            this.opcionbuscar = params.values.opcionbuscar;
        }
        if (params.values.fecha !== undefined) {
            this.fecha = params.values.fecha;
        }
        if (params.values.clave !== undefined) {
            this.clave = params.values.clave;
        }
        if (params.values.checkBool !== undefined) {
            this.checkBool = params.values.checkBool;
        }
        if (params.values.int !== undefined) {
            this.int = params.values.int;
        }
        if (params.values.tamanocelda !== undefined) {
            this.tamanocelda = params.values.tamanocelda;
        }
        if (params.values.tienecalculos !== undefined) {
            this.tienecalculos = params.values.tienecalculos;
        }
        if (params.values.noblanco !== undefined) {
            this.noblanco = params.values.noblanco;
        }
        if (params.values.autorizacion !== undefined) {
            this.noblanco = params.values.noblanco;
        }
        if (params.values.focusout !== undefined) {
            this.focusout = params.values.focusout;
        }
        this.objeto = params.column.colDef.objeto;
        this.columidactual = params.column.colId;
        this.nosaltar = false;
    }

    getValue(): any {
        if (this.fecha === true) {
            if (this.value.toString().includes('-')) {
                this.value = this.datePipe.transform(this.value, 'dd/MM/yyyy');
            } else {
                this.value = this.value;
            }
        }
        console.log('value>>>>>>', this.value)
        return this.value;
    }

    isCancelBeforeStart(): boolean {
        return this.cancelBeforeStart;
    }

    isCancelAfterEnd(): boolean {
        // let rex = new RegExp('^[0-9]*\.[0-9][0-9]$');
        return false;
    }

    onKeyUp(event) {
        if (this.onlymayusculas) {
            try {
                this.value = this.value.toUpperCase();
            } catch (err) {
            }
        }
    }

    focusnewRowEdit() {
        const index = this.gridApi.getFocusedCell().rowIndex;
        const columnas: any = this.params.columnApi.getAllColumns();
        let colid: string;

        colid = columnas[0].colId;
        if (colid !== undefined) {
            this.gridApi.setFocusedCell(index + 1, colid);
            this.gridApi.forEachNode((node) => {
                const h = index + 1;
                if (Number(node.id) === h) {
                    node.setSelected(true);
                }
            });
        }
    }

    onKeyDownFecha(event) {

        if (this.aggrid.notlistenkey === true) {
            event.preventDefault();
            return;
        }

        this.nosaltar = false;
        if (event.keyCode === 13) {
            const index = this.gridApi.getFocusedCell().rowIndex;
            // bandera que permite saber si se puede o no hacer un nuevo registro
            let bandera = true;
            // console.log(index);
            const newdata = {};
            // console.log(this.gridApi.getEditingCells());

            if (this.tienecalculos) {
                this.calculos(event);
            }


            if (this.newrow === true) {

                const immutableStore = [];
                // bandera que permite saber si se puede o no hacer un nuevo registro
                bandera = this.isNewRow(this.params.columnApi.getAllGridColumns(), this.gridApi.getRowNode(index).data);
                if (bandera) {
                    this.gridApi.forEachNode((rowNode, rowindex) => {
                        immutableStore.push(rowNode.data);
                    });
                    immutableStore.splice(index + 1, 0, newdata);

                    this.gridApi.setRowData(immutableStore);
                    this.focusnewRowEdit();
                }
            } else {
                const index = this.gridApi.getFocusedCell().rowIndex;
                const columnas: any = this.params.columnApi.getAllColumns();
                let colid: string;
                let colindex = -1;
                for (const i in columnas) {
                    if (columnas[i].colId === this.columidactual) {
                        colindex = (+i) + this.saltoslinea;
                    }
                    if ((+i) === colindex) {
                        colid = columnas[i].colId;
                    }
                }

                if (colid !== undefined && this.nosaltar === false) {
                    this.gridApi.setFocusedCell(index, colid);
                    this.gridApi.ensureColumnVisible(colid);
                }
            }
        }
    }

    funcionFocusOut(event) {
        if (this.focusout) {
            this.calculos(event);
        }
    }
    //GSRF
    focuact(event) {
        //this.rolProcesoSrv.numcellnomencrol = this.gridApi.getFocusedCell().rowIndex;
        this.encfacproService.numcellfacpro = this.gridApi.getFocusedCell().rowIndex;
        this.encfacproService.idcellfacpro = this.gridApi.getFocusedCell().column.colId;
        this.comDevFacService.idcelldevfacpro = this.gridApi.getFocusedCell().column.colId;
        this.aggrid.idcell = this.gridApi.getFocusedCell().column.colId
        this.idcell1 = this.gridApi.getFocusedCell().column.colId;
        console.log('celllocal ', this.idcell1)
        console.log('cellenvio ', this.aggrid.idcell)
        this.aggrid.rowcell = this.gridApi.getFocusedCell().rowIndex;
        this.rowcell1 = this.gridApi.getFocusedCell().rowIndex;
        console.log('rowcell ', this.aggrid.rowcell)
    }

    focudes(event) {

        if (this.aggrid.displayDialogBusquedaFast !== true
            && event.keyCode !== 13) {
            this.gridApi.stopEditing();
            console.log('AQUIIIIIIUU222222')
            console.log('cellid ', this.idcell1)
            console.log('cellrow', this.rowcell1)
            this.gridApi.setFocusedCell(this.rowcell1, this.idcell1);
            this.gridApi.startEditingCell({ rowIndex: this.rowcell1, colKey: this.idcell1 });
            window.alert('Presione enter para terminar edición de la celda3');
            return;

        }
    }

    //GSRF

    async onKeyDown(event) {
        let immutableStorefac = [];
        if (this.aggrid.notlistenkey === true) {
            event.preventDefault();
            return;
        }
        if (event.key === 'META' || event.key === 'Meta') {
            event.stopPropagation()
            event.preventDefault();
            return;
        }
        // console.log('***>aqui8888 ', this.gridApi.selected)
        // console.log(event)
        // console.log(event.key)
        this.nosaltar = false;
        // console.log(event.key);
        if (event.keyCode === 13 || event.keyCode === 9 || event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40 || event.keyCode === 27) {
            console.log("se preciono el enter");
            const index = this.gridApi.getFocusedCell().rowIndex;
            //GSRF
            this.gridApi.stopEditing();
            this.aggrid.idcell = '';
            this.aggrid.rowcell = '';
            //GSRF
            let bandera = true;
            // bandera que permite saber si se puede o no hacer un nuevo registro
            // console.log(index);
            const newdata = {};
            // console.log(this.gridApi.getEditingCells());

            console.log(this.opcionbuscar)
            if (this.opcionbuscar) {
                console.log("buscar1");
                event.preventDefault();
                this.busquedasEditor();
                return;
            }

            // console.log(this.tienecalculos);
            if (this.tienecalculos) {
                this.calculos(event);
            }

            if (this.noblanco) {
                this.llenarceldas();
            }
            console.log('newrow', this.newrow)
            const columnas: any = this.params.columnApi.getAllColumns();
            let colid: string;
            let colindex = -1;
            for (const i in columnas) {
              if (columnas[i].colId === this.columidactual) {
                colindex = (+i) + this.saltoslinea;
              }
              if ((+i) === colindex) {
                colid = columnas[i].colId;
              }
            }
            console.log(this.nextrow)
            if (this.nextrow === true) {
              this.gridApi.setFocusedCell(index + 1, 'TRNKARDEXOTR_NUMSERIE');
              this.gridApi.ensureColumnVisible(colid);
              return
            }
            console.log('colid',colid)
            if (colid !== undefined) {
              this.gridApi.setFocusedCell(index, colid);
              this.gridApi.ensureColumnVisible(colid);
              this.init.auxsalto = true;
            }
        }

        // let auxiliar = 0;
        // console.log('typeof this.gridApi.getFocusedCell().column.colDef.editable',typeof this.gridApi.getFocusedCell().column.colDef.editable)
        // console.log()
        // if (typeof this.gridApi.getFocusedCell().column.colDef.editable === 'function') {
        //     this.gridApi.forEachNode((node) => {
        //         if (node.selected === true) {
        //             console.log(this.gridApi.getFocusedCell().column.colDef.editable(node))
        //             if (this.gridApi.getFocusedCell().column.colDef.editable(node) === false) {
        //                 auxiliar++;
        //             }
        //         }
        //     });
        // }

        // if (auxiliar > 0) {
        //     console.log("buscaraux");
        //     event.preventDefault();
        // }
        // const indexfac = this.gridApi.getFocusedCell().rowIndex;
        // this.gridApi.forEachNode((rowNode, rowindex) => {
        //     immutableStorefac.push(rowNode.data);
        // });
        // console.log(this.objeto)
        // console.log(this.columidactual)
        // console.log(immutableStorefac[indexfac].BOOL_TOKEN)
        // if (this.objeto === 'detfac' && (this.columidactual === 'DETFAC_PRECIO' || this.columidactual === 'DETFAC_DESCUENTO') && immutableStorefac[indexfac].BOOL_TOKEN === false) {

        //     try {
        //         const CEPDF = this.encfacservice.hmpConfiguracion.find(element => element.CFG_CODIGO === 'CEPDF').CFG_VALOR1;


        //         if (CEPDF === 1) {
        //             this.gridApi.stopEditing();
        //             const rs = await this.utilitariosService.enviarCorreoTokenAutEditpredescfac(this.encfacservice.usuarioEsquema.esquema,
        //                 this.encfacservice.usuario.identificacion, this.columidactual
        //             );
        //             if (rs) {
        //                 this.encfacservice.tokenusuario = '';
        //                 this.encfacservice.displayToken = true;
        //                 this.encfacservice.tipotoken = 'BOLPD';
        //                 this.encfacservice.columnaactual = this.columidactual
        //                 event.preventDefault();
        //             }
        //         }
        //     } catch (error) {
        //         this.messageService.add({
        //             key: 'encfac',
        //             severity: 'error',
        //             summary: 'Información',
        //             detail: 'Ocurrió un error al enviar el token ' + error.error
        //         });
        //     }

        // }
        if (this.value !== '' && this.clave === true) {
            console.log("buscaraux2");
            this.gridApi.stopEditing();

            this.encfacservice.displaydialogsuperuser = true
            this.encfacservice.columnaactual = this.columidactual
            event.preventDefault();
        } else {
            this.clave = false;
        }

        if (this.onlynumber === false && this.onlyalphabetic === false) {
            this.ExpReg2(event);
        }


        //CDPJ
        if (this.onlynumber && this.onlyalphabetic === false && this.onlynumberposneg === true) {
            this.ExpRegposneg(event);
        } else {
            if (this.onlynumber && this.onlyalphabetic === false) {
                this.ExpReg(event);
            } else {
                if (!this.isKeyPressedNumeric(event)) {
                    if (event.preventDefault) {
                        event.preventDefault();
                    }
                }
            }
        }
        //CDPJ
    }

    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        setTimeout(() => {
            this.input.element.nativeElement.focus();
        });
    }

    private getCharCodeFromEvent(event): any {
        event = event || window.event;
        return (typeof event.which === 'undefined') ? event.keyCode : event.which;
    }

    private isAlphabetic(charStr): boolean {

        const str = new RegExp('/^[A-z]');
        return /[a-zA-Z ]+/.test(charStr);
    }

    private isCharNumeric(charStr): boolean {
        console.log(charStr);
        let text;
        let conpuntos;
        let numdecimales = 0;
        if (this.value !== undefined) {
            text = this.value.toString();
            conpuntos = text.indexOf('.');
            text += charStr;
            try {
                numdecimales = text.split('.')[1].length;
                // se obtiene el numero de decimales
            } catch (err) {
                numdecimales = 0;
            }
        } else {
            conpuntos = -1;
        }
        if (charStr === 'Backspace') {
            return true;
        } else {
            if (this.decimales === 0) {
                try {
                    const num = +charStr;
                    if (num > -1 && charStr !== '.') {
                        return true;
                    } else {
                        return false;
                    }
                } catch (err) {
                    return false;
                }
            }
            if (numdecimales > this.decimales) {
                return false;
            } else {
                if (charStr === '.') {
                    if (conpuntos >= 0) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    try {
                        const num = +charStr;
                        if (num > -1) {
                            return true;
                        }
                    } catch (err) {
                        return false;
                    }
                }
            }
        }
        // return /^\d(\.\d)*$/.test(charStr);
    }

    private isKeyPressedNumeric(event): boolean {
        const charCode = this.getCharCodeFromEvent(event);
        const charStr = event.key ? event.key : String.fromCharCode(charCode);
        if (this.onlyalphabetic && this.onlynumber) {
            return true;
        } else {
            if (this.onlyalphabetic) {
                return this.isAlphabetic(charStr);
            } else if (this.onlynumber) {
                return this.esCaracterNumerico(charStr);
            } else {
                return false;
            }
        }
        // return true;
    }

    private busqueda(columnas, data): boolean {
        let bandera = true;
        for (const col of columnas) {
            try {
                if (col.colDef.cellEditorParams.values.opcionbuscar) {
                    if (data[col.colId] === undefined || data[col.colId] === null || data[col.colId] === '') {
                        return false;
                    }
                }
            } catch (err) {
                bandera = true;
            }
        }
        return bandera;
    }

    private isNewRow(columnas, data): boolean {
        // console.log(columnas, data);
        let bandera = true;
        for (const col of columnas) {
            try {
                if (col.colDef.cellEditorParams.values.obligatorio) {
                    if (data[col.colId] === undefined || data[col.colId] === null || data[col.colId] === '') {
                        return false;
                    }
                }
            } catch (err) {
                bandera = true;
            }
        }
        return bandera;
    }


    private esCaracterNumerico(charStr): boolean {
        // console.log(charStr);


        if (charStr === 'Dead') {
            return false;
        }
        if (charStr === '-') {
            return false;
        }

        let text;
        let conpuntos;
        let numdecimales = 0;
        if (this.value !== undefined) {
            text = this.value.toString();
            conpuntos = text.indexOf('.');
            text += charStr;
            try {
                numdecimales = text.split('.')[1].length; // se obtiene el numero de decimales
            } catch (err) {
                numdecimales = 0;
            }
        } else {
            conpuntos = -1;
        }
        if (charStr === 'Backspace') {
            return true;
        } else {
            if (this.decimales === 0) {
                try {
                    const num = +charStr;
                    if (num > -1 && charStr !== '.') {
                        return true;
                    } else {
                        return false;
                    }
                } catch (err) {
                    return false;
                }
            }
            if (numdecimales > this.decimales) {
                return false;
            } else {
                if (charStr === '.') {
                    if (conpuntos >= 0) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    try {
                        const num = +charStr;
                        if (num > -1) {
                            return true;
                        }
                    } catch (err) {
                        return false;
                    }
                }
            }
        }

        // return /^\d(\.\d)*$/.test(charStr);
    }

    ExpReg(event) {
        console.log('positivos')
        const expresion = '^\\d*\\.?\\d{0,' + this.decimales + '}$';
        const regex: RegExp = new RegExp(expresion, 'g');
        const specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ñ', 'Ñ'];
        if (specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const next: string = (this.value + '').concat(event.key);
        if (next && !String(next).match(regex)) {
            event.preventDefault();
        }
    }
    ExpRegposneg(event) {
        console.log('negativos')
        const expresion = '^-?\\d*\\.?\\d{0,' + this.decimales + '}$';
        const regex: RegExp = new RegExp(expresion, 'g');
        const specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ñ', 'Ñ'];
        if (specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const next: string = (this.value + '').concat(event.key);
        if (next && !String(next).match(regex)) {
            event.preventDefault();
        }
    }
    ExpReg2(event) {
        const specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ñ', 'Ñ'];
        if (specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        event.preventDefault();
    }

    busquedasEditor() {
        const index = this.gridApi.getFocusedCell().rowIndex;
        const immutableStore = [];
        this.gridApi.stopEditing();
        this.gridApi.forEachNode((rowNode, rowindex) => {
            immutableStore.push(rowNode.data);
        });
        console.log("columna", this.columidactual);

        // if (this.columidactual === 'ART_CODIGOP') {
        //   if (this.gridApi.aggFuncService === 'maeartparte') {
        //     this.aggrid.busquedaarticulodetalle(immutableStore[index], 'busquedaarticuloparte', immutableStore[index].ART_CODIGOP);
        //   }
        //   if (this.gridApi.aggFuncService === 'maeartformula') {
        //     this.aggrid.busquedaarticulodetalle(immutableStore[index], 'busquedaarticuloformula', immutableStore[index].ART_CODIGOP);
        //   }
        // }
        if (this.columidactual === 'BOD_CODIGO') {

            if (this.gridApi.aggFuncService === 'detcotiza') {
                this.aggrid.busquedabodega(immutableStore[index], 'BOD_CODIGO');
            }
        }
        if (this.columidactual === 'BOD_CODIGO') {

            if (this.gridApi.aggFuncService === 'detcotiza') {
                this.aggrid.busquedabodega(immutableStore[index], 'BOD_CODIGO');
            }
        }
        if (this.columidactual === 'DETCOTIZA_CODIGO') {
            if (this.gridApi.aggFuncService === 'detcotiza') {
                if (immutableStore[index].DETCOTIZA_TIPODET === 'A') {

                    this.aggrid.busquedaarticulodetalle(immutableStore[index], 'busquedaarticulo', immutableStore[index].DETCOTIZA_CODIGO);
                }
                if (immutableStore[index].DETCOTIZA_TIPODET === 'S') {
                    // this.busquedaserviciodetalle(immutableStore[index], 'busquedaserviciodetfacpro', immutableStore[index].DETFACPRO_CODIGO);
                    this.aggrid.busquedaservicioPedido(immutableStore[index], 'busquedaservicio', immutableStore[index].DETPED_CODIGO);
                }
                if (immutableStore[index].DETCOTIZA_TIPODET === 'I') {
                    this.aggrid.busquedacostosind(immutableStore[index], 'busquedacostosindi');
                }
            }
        }
        if (this.columidactual === 'PRO_CODIGO') {
            if (this.gridApi.aggFuncService === 'detcotiza') {
                this.aggrid.busquedaprove(immutableStore[index], 'PRO_CODIGO');
            }
        }
    }

    async calculos(event) {
        const index = this.gridApi.getFocusedCell().rowIndex;
        console.log(index)
        const immutableStore = [];
        const rowNode=this.gridApi.getDisplayedRowAtIndex(
            index
        )
        this.gridApi.stopEditing();
        this.gridApi.forEachNode((rowNode, rowindex) => {
            immutableStore.push(rowNode.data);
        });
        console.log(this.gridApi)
        if (this.gridApi.aggFuncService === 'detcotiza') {
            if (this.columidactual === 'DETCOTIZA_CANTIDAD' || this.columidactual === 'DETCOTIZA_COSTO') {
                this.venenccotizacionService.calculartotal(immutableStore[index].ENCCOTIZA_NUMERO)
                this.gridApi.refreshCells({
                    rowNodes:[rowNode],
                    force:true
                })
            }
        }

     



    }


    llenarceldas() {
        // const index = this.gridApi.getFocusedCell().rowIndex;
        // const immutableStore = [];
        // this.gridApi.stopEditing();
        // this.gridApi.forEachNode((rowNode, rowindex) => {
        //   immutableStore.push(rowNode.data);
        // });
        // if (this.gridApi.aggFuncService === 'detfac') {
        //   if (this.columidactual === 'DETFAC_TRIBIVA') {
        //     if (immutableStore[index].DETFAC_TRIBIVA === '') {
        //       immutableStore[index].DETFAC_TRIBIVA = immutableStore[index].DETFAC_TRIBIVAAUX;
        //     }
        //     this.aggrid.refreshaggrid(this.encfacservice.detfacarray[this.init.tabs[this.init.tabindex].indice], 'detfac');
        //   }
        // }
    }
    //CDPJ
    async verificarSaldoLoteML(lote, artcod) {
        const index = this.gridApi.getFocusedCell().rowIndex;
        const immutableStore = [];
        this.gridApi.stopEditing();
        this.gridApi.forEachNode((rowNode, rowindex) => {
            immutableStore.push(rowNode.data);
        });
        let dblsaldo = 0
        let dblCantidadReg = 0;
        //cantidad grabada actualmente en el documento 
        const data = await this.trnloteservice.cantidadgrabada(immutableStore[index].TRNLOTE_DOCUMENTO, immutableStore[index].TRNLOTE_LINEADOC);
        // saldo
        const data2 = await this.trnloteservice.cantidadsaldo(lote, artcod);
        if (data !== null && data !== undefined && data.length > 0) {
            for (const item of data) {
                dblCantidadReg = Number(item.TRNLOTE_CANTIDAD)
            }
        }
        if (data2 !== null && data2 !== undefined && data2.length > 0) {
            for (const item of data2) {
                dblsaldo = Number(item.SALDO)
            }
        }

        dblsaldo = dblsaldo + dblCantidadReg
        return dblsaldo;

    }
    async verificarSaldo(lote, artcod) {
        const index = this.gridApi.getFocusedCell().rowIndex;
        const immutableStore = [];
        this.gridApi.stopEditing();
        this.gridApi.forEachNode((rowNode, rowindex) => {
            immutableStore.push(rowNode.data);
        });
        let dblsaldo = 0
        let dblCantidadReg = 0;
        //cantidad grabada actualmente en el documento 
        const data = await this.trnloteservice.cantidadgrabada(immutableStore[index].TRNLOTE_DOCUMENTO, immutableStore[index].TRNLOTE_LINEADOC);
        // saldo
        const data2 = await this.trnloteservice.cantidadsaldo2(lote, artcod);
        if (data !== null && data !== undefined && data.length > 0) {
            for (const item of data) {
                dblCantidadReg = Number(item.TRNLOTE_CANTIDAD)
            }
        }
        if (data2 !== null && data2 !== undefined && data2.length > 0) {
            for (const item of data2) {
                dblsaldo = Number(item.SALDO)
            }
        }

        dblsaldo = dblsaldo + dblCantidadReg
        return dblsaldo;

    }
    //CDPJ
}
